import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import NewHomeSlider from '../components/NewHomeSlider/NewHomeSlider';
import NewGeneralSearchForm from '@/components/general/Forms/NewGeneralSearchForm/NewGeneralSearchForm';
import ReactPixel from 'react-facebook-pixel';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import { SearchComponent } from '@/components/general/SearchComponent';

const StillBuildingHomeView = props => {
  const { spacesDataFromBackend, blogsDataFromBackend, lenguage } = props;
  const lenguageData = lenguage;
  const [isVisibleNewForm, setIsVisibleNewForm] = useState(false);
  const [searchType, setSearchType] = useState('');
  const [spacesToShow, setSpacesToShow] = useState(null);

  const showNewForm = type => {
    window.scrollTo(0, 0);
    setIsVisibleNewForm(true);
    ReactPixel.trackCustom('SelectSearchType', { clave: type });
    window.history.replaceState(null, '', '/elige-tu-experiencia');
    if (type === 'Coworking') {
      setSpacesToShow(
        spacesDataFromBackend.filter(item =>
          item.subtype_title?.toLowerCase().includes('coworking'),
        ),
      );
    } else {
      setSpacesToShow(
        spacesDataFromBackend.filter(item =>
          item.subtype_title?.toLowerCase().includes('sala'),
        ),
      );
    }
    console.log('ver', spacesToShow);
    setSearchType(type);
  };

  const hideNewForm = () => {
    window.scrollTo(0, 0);
    setIsVisibleNewForm(false);
    setSearchType('');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fistSliderLabel =
    lenguageData === 'ES'
      ? 'Espacios de coworking bajo demanda en Ciudad de México'
      : 'On Demand Coworking Spaces in Mexico City';

  const firstSequence = [
    fistSliderLabel,
    1000,
    fistSliderLabel,
    1000,
    fistSliderLabel,
    1000,
    fistSliderLabel,
    1000,
  ];

  const sliderLabel =
    lenguageData === 'ES'
      ? 'Espacios de coworking bajo demanda en Ciudad de México'
      : 'On Demand Coworking Spaces in Mexico City';

  const firstImagesArray = ['spaces/fondo1.png'];

  const mobileImageItemStyle = {
    width: '100%',
    height: '450px',
    objectFit: 'cover',
  };

  const esDescription =
    'Somos un equipo de apasionados por la innovación y el buen vivir. Ofrecemos espacios de trabajo únicos con privacidad, buen diseño y sin ruido.';
  const enDescription =
    'We are a team of people passionate about innovation and good living. We offer unique work spaces with privacy, good design and no noise.';

  const ChatBubble = props => {
    const { extraClass, text } = props;
    return (
      <FlexContainer
        className={
          'bgTransparentPink grayShadowBottom borderRad16 fontWhite margl10 padlr6 padtb20 pos-abs width-300px ' +
          extraClass
        }
        style={{ zIndex: 1 }}
      >
        {text}
      </FlexContainer>
    );
  };

  return (
    <div className="App">
      <HelmetComponent
        title={lenguageData === 'EN' ? 'Home - Popnest' : 'Inicio - Popnest'}
        description={lenguageData === 'EN' ? enDescription : esDescription}
        graphTitle={
          lenguageData === 'EN' ? 'Home - Popnest' : 'Inicio - Popnest'
        }
        graphDescription={lenguageData === 'EN' ? enDescription : esDescription}
      />
      <FlexContainer
        className={isVisibleNewForm ? 'bgWhite m-flex-column' : 'm-flex-column'}
      >
        {isVisibleNewForm && (
          <>
            <FlexContainer
              className={
                'flex-column margt100 m-margt120 format100 m-formatAuto padlr40 m-padlr0 d-hide'
              }
            >
              <button
                type="button"
                className={
                  'pointer bgWhite border-rad4px padlr20 marglr10 padtb6 borderGray050 fontGray500 text-16 m-margt40'
                }
                onClick={() => hideNewForm()}
              >
                <i className={'fa fa-arrow-left margr6'} aria-hidden="true" />
                {lenguageData === 'ES' ? 'Atrás' : 'Back'}
              </button>
              <NewGeneralSearchForm searchType={searchType} />
            </FlexContainer>
            <FlexContainer className={'margt90 m-hide'}></FlexContainer>
          </>
        )}
        {!isVisibleNewForm && (
          <>
            <NewHomeSlider
              spacesData={spacesDataFromBackend}
              personalizedContainerClass={'format100 m-margt50'}
              personalizedPlaceholder={
                lenguageData === 'ES' ? 'Dónde' : 'Where'
              }
              sequence={firstSequence}
              sliderLabel={sliderLabel}
              imagesArray={firstImagesArray}
              showNewForm={() => showNewForm('Sala')}
            />
          </>
        )}
      </FlexContainer>
      <FlexContainer
        className={
          'bgGradientPurple items-align-center padtb100 width100 flex-column'
        }
      >
        <FlexContainer className={'flex-column'}>
          <Label type="text-20" className={'fontWhite'}>
            <strong>
              {lenguageData === 'ES'
                ? 'Recibe un mes de LinkedIn Premium'
                : 'Receive one month of LinkedIn premium'}
            </strong>
          </Label>
          <Label type="text-20" className={'fontWhite'}>
            {lenguageData === 'ES'
              ? 'después de gastar $6,000 en reservaciones'
              : 'after spending $6,000 in reservations'}
          </Label>
          <Label type="text-14" className={'fontWhite margt10'}>
            <strong>
              {lenguageData === 'ES'
                ? 'Válido durante un año. Ver términos.'
                : 'Valid for one year. See Terms'}
            </strong>
          </Label>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer
        className={'bgPurple9 items-align-center padtb100 width100 flex-column'}
      >
        <FlexContainer className={'flex-column'}>
          <Label type="text-36" className={'fontWhite'}>
            <strong>
              {lenguageData === 'ES'
                ? 'Aquí está la razón por la que la gente usa Popnest'
                : 'Here is why people use Popnest'}
            </strong>
          </Label>
        </FlexContainer>
        <FlexContainer className={'padlr120 margt60 gap-60'}>
          <FlexContainer className={'flex-column width100'}>
            <FlexContainer column className={'align-items-center'}>
              <img src={'icons/icon1.png'} className="width-120px" />
            </FlexContainer>
            <Label type="text-18" className={'fontWhite text-center margt20'}>
              <strong>
                {lenguageData === 'ES'
                  ? 'Rapidez para reservar'
                  : 'Speed to Book'}
              </strong>
            </Label>
            <Label type="text-18" className={'fontWhite text-center'}>
              {lenguageData === 'ES'
                ? 'Reserva en segundos. Sin formularios, sin fricción.'
                : 'Reserve in seconds. No forms, no friction'}
            </Label>
          </FlexContainer>
          <FlexContainer className={'flex-column width100'}>
            <FlexContainer column className={'align-items-center'}>
              <img src={'icons/icon2.png'} className="width-120px" />
            </FlexContainer>
            <Label type="text-18" className={'fontWhite text-center margt30'}>
              <strong>
                {lenguageData === 'ES'
                  ? 'Espacios hermosos'
                  : 'Beautiful Spaces'}
              </strong>
            </Label>
            <Label type="text-18" className={'fontWhite text-center'}>
              {lenguageData === 'ES'
                ? 'Diseñado para creativos, equipos y viajeros'
                : 'Designed for creatives, teams, and travelers'}
            </Label>
          </FlexContainer>
          <FlexContainer className={'flex-column width100'}>
            <FlexContainer column className={'align-items-center'}>
              <img src={'icons/icon3.png'} className="width-120px" />
            </FlexContainer>
            <Label type="text-18" className={'fontWhite text-center margt20'}>
              <strong>
                {lenguageData === 'ES'
                  ? 'Ventajas muy pronto'
                  : 'Perks Coming Soon'}
              </strong>
            </Label>
            <Label type="text-18" className={'fontWhite text-center'}>
              {lenguageData === 'ES'
                ? 'Los miembros iniciales obtendrán beneficios como descuentos en restaurantes.'
                : 'Early members will get perks like restaurant discounts'}
            </Label>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer
        className={'items-align-center width100 parentDarkOverlay'}
      >
        <FlexContainer className={'flex-column width100'}>
          <ChatBubble
            extraClass={'margt180'}
            text={
              "Definitely one of the best coworking spaces in Coyoacan. For the price/quality ratio and privacy, it's an excellent choice for working. The atmosphere, chairs, and facilities are very comfortable, as is the tea and coffee bar. I'm truly happy with the experience."
            }
          />
          <img
            src={'icons/personaje1.png'}
            alt={''}
            style={{
              ...mobileImageItemStyle,
            }}
          />
        </FlexContainer>
        <FlexContainer className={'flex-column width100'}>
          <ChatBubble
            extraClass={'margt30'}
            text={'Excellent place to work with a lot of tranquility'}
          />

          <img
            src={'icons/personaje4.jpg'}
            alt={''}
            style={{
              ...mobileImageItemStyle,
            }}
          />
        </FlexContainer>
        <FlexContainer className={'flex-column width100'}>
          <ChatBubble
            extraClass={'margt130'}
            text={
              'I’ve been using this coworking space for a few weeks now and it honestly surprised me. The space is very well designed, it gets plenty of natural light, and it feels much more relaxed than the typical chain coworking spaces'
            }
          />

          <img
            src={'icons/personaje3.jpg'}
            alt={''}
            style={{
              ...mobileImageItemStyle,
            }}
          />
        </FlexContainer>
        <FlexContainer className={'flex-column width100'}>
          <ChatBubble
            extraClass={'margt180'}
            text={
              'The place is very pretty, very colorful, well-lit, clean, and quiet. Excellent service from the staff; definitely a great place to work. I highly recommend it.'
            }
          />
          <img
            src={'icons/personaje2.png'}
            alt={''}
            style={{
              ...mobileImageItemStyle,
            }}
          />
        </FlexContainer>
      </FlexContainer>
    </div>
  );
};

export default StillBuildingHomeView;
